var map = {
	"./comments.svg": 758,
	"./copy-link.svg": 729,
	"./facebook.svg": 810,
	"./like-fill.svg": 756,
	"./like.svg": 757,
	"./ok.svg": 811,
	"./share.svg": 759,
	"./telegram.svg": 812,
	"./twitter.svg": 813,
	"./vk.svg": 814,
	"./whatsapp.svg": 815
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 809;